import { TranslateResult } from 'vue-i18n';
import { ListItemModel, ContentModel } from '@descomplica/dex-models';
import i18n from '../i18n';
import { getPaddedDisplayNumber } from '@/helpers/string';

const icons: any = {
  video: 'play',
  question: 'listCheck',
  trivia: 'comment',
  article: 'file',
  practice: 'practicalExercises',
};

class ListItemMenuModel {
  listItemList: ListItemModel[];

  constructor(listItem: ListItemModel) {
    this.listItemList = [listItem];
  }

  get id(): number {
    return this.item.id;
  }

  get behavior(): string | undefined {
    return this.item.behavior;
  }

  get item(): ListItemModel {
    return this.listItemList[0];
  }

  get quantity(): number {
    return this.listItemList.length;
  }

  get label(): TranslateResult | string {
    if (this.item.isObjective()) return i18n.tc('exercise', 1);
    if (this.item.isDiscursive()) return i18n.t('trivia');
    if (this.item.isPractice()) return i18n.t('practice');
    if (this.item.isArticle())
      return this.item.article ? this.item.article.title : i18n.tc('article', 1);
    if (this.item.isVideo()) return this.item.video ? this.item.video.name : i18n.tc('video', 1);
    return '';
  }

  get description(): TranslateResult | string {
    if (this.item.isObjective()) {
      return `${this.quantity} ${i18n.tc('question', this.quantity).toLocaleLowerCase()}`;
    }

    if (this.item.isDiscursive()) return `1 ${i18n.tc('question', 1).toLocaleLowerCase()}`;

    if (this.item.isPractice()) return `1 ${i18n.tc('question', 1).toLocaleLowerCase()}`;

    if (this.item.isArticle() && this.item.article) {
      const wordsPerMinute = 250;
      const totalWords = this.item.article.contents.reduce((acc: number, content: ContentModel) => {
        if (content && content.isText()) {
          // Just to avoid html tags
          const div = document.createElement('div');
          div.innerHTML = content.text.body;
          const text = div.textContent || div.innerText || '';
          return acc + text.split(' ').length;
        }
        return acc;
      }, 0);
      const readingMinutes = totalWords / wordsPerMinute;
      return `${readingMinutes.toFixed()} ${i18n.tc('readingMinutes', readingMinutes)}`;
    }

    if (this.item.isVideo() && this.item.video) {
      if (!this.item.video.duration) return '';
      const videoMinutes = Math.trunc(this.item.video.duration / 60);
      const videoSeconds = this.item.video.duration % 60;
      const videoMinutesFormatted = getPaddedDisplayNumber(videoMinutes);
      const videoSecondsFormatted = getPaddedDisplayNumber(videoSeconds);
      return `${videoMinutesFormatted}:${videoSecondsFormatted}`;
    }
    return '';
  }

  get icon(): String {
    if (this.item.behavior && Object.keys(icons).includes(this.item.behavior))
      return icons[this.item.behavior];
    return '';
  }

  get progress(): number {
    let progress = 0;
    this.listItemList.forEach((listItem: ListItemModel) => {
      progress += listItem.progress;
    });
    return progress / this.listItemList.length;
  }

  addListItem(listItem: ListItemModel): void {
    this.listItemList.push(listItem);
  }

  isCompleted(): Boolean {
    return this.progress === 100;
  }
}

export default ListItemMenuModel;
